require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./cljs.core.async.impl.protocols.js");

require("./cljs.core.async.impl.dispatch.js");

require("./cljs.core.async.impl.buffers.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("cljs.core.async.impl.channels.js");
goog.provide('cljs.core.async.impl.channels');

cljs.core.async.impl.channels.box = function cljs$core$async$impl$channels$box(val) {
  if (typeof cljs !== 'undefined' && typeof cljs.core !== 'undefined' && typeof cljs.core.async !== 'undefined' && typeof cljs.core.async.impl !== 'undefined' && typeof cljs.core.async.impl.channels !== 'undefined' && typeof cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997 !== 'undefined') {} else {
    /**
    * @constructor
     * @implements {cljs.core.IMeta}
     * @implements {cljs.core.IDeref}
     * @implements {cljs.core.IWithMeta}
    */
    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997 = function (val, meta25998) {
      this.val = val;
      this.meta25998 = meta25998;
      this.cljs$lang$protocol_mask$partition0$ = 425984;
      this.cljs$lang$protocol_mask$partition1$ = 0;
    };

    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997.prototype.cljs$core$IWithMeta$_with_meta$arity$2 = function (_25999, meta25998__$1) {
      var self__ = this;

      var _25999__$1 = this;

      return new cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997(self__.val, meta25998__$1);
    };

    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997.prototype.cljs$core$IMeta$_meta$arity$1 = function (_25999) {
      var self__ = this;

      var _25999__$1 = this;

      return self__.meta25998;
    };

    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997.prototype.cljs$core$IDeref$_deref$arity$1 = function (_) {
      var self__ = this;

      var ___$1 = this;

      return self__.val;
    };

    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997.getBasis = function () {
      return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "val", "val", 1769233139, null), new cljs.core.Symbol(null, "meta25998", "meta25998", -1497366946, null)], null);
    };

    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997.cljs$lang$type = true;
    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997.cljs$lang$ctorStr = "cljs.core.async.impl.channels/t_cljs$core$async$impl$channels25997";

    cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997.cljs$lang$ctorPrWriter = function (this__4369__auto__, writer__4370__auto__, opt__4371__auto__) {
      return cljs.core._write(writer__4370__auto__, "cljs.core.async.impl.channels/t_cljs$core$async$impl$channels25997");
    };
    /**
     * Positional factory function for cljs.core.async.impl.channels/t_cljs$core$async$impl$channels25997.
     */


    cljs.core.async.impl.channels.__GT_t_cljs$core$async$impl$channels25997 = function cljs$core$async$impl$channels$box_$___GT_t_cljs$core$async$impl$channels25997(val__$1, meta25998) {
      return new cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997(val__$1, meta25998);
    };
  }

  return new cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997(val, cljs.core.PersistentArrayMap.EMPTY);
};
/**
* @constructor
*/


cljs.core.async.impl.channels.PutBox = function (handler, val) {
  this.handler = handler;
  this.val = val;
};

cljs.core.async.impl.channels.PutBox.getBasis = function () {
  return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "handler", "handler", 1444934915, null), new cljs.core.Symbol(null, "val", "val", 1769233139, null)], null);
};

cljs.core.async.impl.channels.PutBox.cljs$lang$type = true;
cljs.core.async.impl.channels.PutBox.cljs$lang$ctorStr = "cljs.core.async.impl.channels/PutBox";

cljs.core.async.impl.channels.PutBox.cljs$lang$ctorPrWriter = function (this__4369__auto__, writer__4370__auto__, opt__4371__auto__) {
  return cljs.core._write(writer__4370__auto__, "cljs.core.async.impl.channels/PutBox");
};
/**
 * Positional factory function for cljs.core.async.impl.channels/PutBox.
 */


cljs.core.async.impl.channels.__GT_PutBox = function cljs$core$async$impl$channels$__GT_PutBox(handler, val) {
  return new cljs.core.async.impl.channels.PutBox(handler, val);
};

cljs.core.async.impl.channels.put_active_QMARK_ = function cljs$core$async$impl$channels$put_active_QMARK_(box) {
  return cljs.core.async.impl.protocols.active_QMARK_(box.handler);
};

cljs.core.async.impl.channels.MAX_DIRTY = 64;
/**
 * @interface
 */

cljs.core.async.impl.channels.MMC = function () {};

var cljs$core$async$impl$channels$MMC$abort$dyn_26123 = function cljs$core$async$impl$channels$MMC$abort$dyn_26123(this$) {
  var x__4428__auto__ = this$ == null ? null : this$;
  var m__4429__auto__ = cljs.core.async.impl.channels.abort[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(this$) : m__4429__auto__.call(null, this$);
  } else {
    var m__4426__auto__ = cljs.core.async.impl.channels.abort["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(this$) : m__4426__auto__.call(null, this$);
    } else {
      throw cljs.core.missing_protocol("MMC.abort", this$);
    }
  }
};

cljs.core.async.impl.channels.abort = function cljs$core$async$impl$channels$abort(this$) {
  if (!(this$ == null) && !(this$.cljs$core$async$impl$channels$MMC$abort$arity$1 == null)) {
    return this$.cljs$core$async$impl$channels$MMC$abort$arity$1(this$);
  } else {
    return cljs$core$async$impl$channels$MMC$abort$dyn_26123(this$);
  }
};
/**
* @constructor
 * @implements {cljs.core.async.impl.channels.MMC}
 * @implements {cljs.core.async.impl.protocols.Channel}
 * @implements {cljs.core.async.impl.protocols.WritePort}
 * @implements {cljs.core.async.impl.protocols.ReadPort}
*/


cljs.core.async.impl.channels.ManyToManyChannel = function (takes, dirty_takes, puts, dirty_puts, buf, closed, add_BANG_) {
  this.takes = takes;
  this.dirty_takes = dirty_takes;
  this.puts = puts;
  this.dirty_puts = dirty_puts;
  this.buf = buf;
  this.closed = closed;
  this.add_BANG_ = add_BANG_;
};

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$channels$MMC$ = cljs.core.PROTOCOL_SENTINEL;

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$channels$MMC$abort$arity$1 = function (this$) {
  var self__ = this;
  var this$__$1 = this;

  while (true) {
    var putter_26125 = self__.puts.pop();

    if (putter_26125 == null) {} else {
      var put_handler_26126 = putter_26125.handler;
      var val_26127 = putter_26125.val;

      if (put_handler_26126.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null)) {
        var put_cb_26128 = put_handler_26126.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
        cljs.core.async.impl.dispatch.run(function (put_cb_26128, put_handler_26126, val_26127, putter_26125, this$__$1) {
          return function () {
            return put_cb_26128.cljs$core$IFn$_invoke$arity$1 ? put_cb_26128.cljs$core$IFn$_invoke$arity$1(true) : put_cb_26128.call(null, true);
          };
        }(put_cb_26128, put_handler_26126, val_26127, putter_26125, this$__$1));
      } else {
        continue;
      }
    }

    break;
  }

  self__.puts.cleanup(cljs.core.constantly(false));
  return this$__$1.cljs$core$async$impl$protocols$Channel$close_BANG_$arity$1(null);
};

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$protocols$WritePort$ = cljs.core.PROTOCOL_SENTINEL;

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$protocols$WritePort$put_BANG_$arity$3 = function (this$, val, handler) {
  var self__ = this;
  var this$__$1 = this;

  if (!(val == null)) {} else {
    throw new Error(["Assert failed: ", "Can't put nil on a channel", "\n", "(not (nil? val))"].join(''));
  }

  var closed__$1 = self__.closed;

  if (closed__$1 || !handler.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null)) {
    return cljs.core.async.impl.channels.box(!closed__$1);
  } else {
    if (cljs.core.truth_(function () {
      var and__4115__auto__ = self__.buf;

      if (cljs.core.truth_(and__4115__auto__)) {
        return cljs.core.not(self__.buf.cljs$core$async$impl$protocols$Buffer$full_QMARK_$arity$1(null));
      } else {
        return and__4115__auto__;
      }
    }())) {
      handler.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
      var done_QMARK_ = cljs.core.reduced_QMARK_(self__.add_BANG_.cljs$core$IFn$_invoke$arity$2 ? self__.add_BANG_.cljs$core$IFn$_invoke$arity$2(self__.buf, val) : self__.add_BANG_.call(null, self__.buf, val));

      var take_cbs = function () {
        var takers = cljs.core.PersistentVector.EMPTY;

        while (true) {
          if (self__.takes.length > 0 && cljs.core.count(self__.buf) > 0) {
            var taker = self__.takes.pop();

            if (taker.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null)) {
              var ret = taker.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
              var val__$1 = self__.buf.cljs$core$async$impl$protocols$Buffer$remove_BANG_$arity$1(null);
              var G__26132 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(takers, function (takers, ret, val__$1, taker, done_QMARK_, closed__$1, this$__$1) {
                return function () {
                  return ret.cljs$core$IFn$_invoke$arity$1 ? ret.cljs$core$IFn$_invoke$arity$1(val__$1) : ret.call(null, val__$1);
                };
              }(takers, ret, val__$1, taker, done_QMARK_, closed__$1, this$__$1));
              takers = G__26132;
              continue;
            } else {
              var G__26133 = takers;
              takers = G__26133;
              continue;
            }
          } else {
            return takers;
          }

          break;
        }
      }();

      if (done_QMARK_) {
        this$__$1.cljs$core$async$impl$channels$MMC$abort$arity$1(null);
      } else {}

      if (cljs.core.seq(take_cbs)) {
        var seq__26004_26134 = cljs.core.seq(take_cbs);
        var chunk__26005_26135 = null;
        var count__26006_26136 = 0;
        var i__26007_26137 = 0;

        while (true) {
          if (i__26007_26137 < count__26006_26136) {
            var f_26138 = chunk__26005_26135.cljs$core$IIndexed$_nth$arity$2(null, i__26007_26137);
            cljs.core.async.impl.dispatch.run(f_26138);
            var G__26139 = seq__26004_26134;
            var G__26140 = chunk__26005_26135;
            var G__26141 = count__26006_26136;
            var G__26142 = i__26007_26137 + 1;
            seq__26004_26134 = G__26139;
            chunk__26005_26135 = G__26140;
            count__26006_26136 = G__26141;
            i__26007_26137 = G__26142;
            continue;
          } else {
            var temp__5804__auto___26143 = cljs.core.seq(seq__26004_26134);

            if (temp__5804__auto___26143) {
              var seq__26004_26144__$1 = temp__5804__auto___26143;

              if (cljs.core.chunked_seq_QMARK_(seq__26004_26144__$1)) {
                var c__4556__auto___26145 = cljs.core.chunk_first(seq__26004_26144__$1);
                var G__26146 = cljs.core.chunk_rest(seq__26004_26144__$1);
                var G__26147 = c__4556__auto___26145;
                var G__26148 = cljs.core.count(c__4556__auto___26145);
                var G__26149 = 0;
                seq__26004_26134 = G__26146;
                chunk__26005_26135 = G__26147;
                count__26006_26136 = G__26148;
                i__26007_26137 = G__26149;
                continue;
              } else {
                var f_26150 = cljs.core.first(seq__26004_26144__$1);
                cljs.core.async.impl.dispatch.run(f_26150);
                var G__26159 = cljs.core.next(seq__26004_26144__$1);
                var G__26160 = null;
                var G__26161 = 0;
                var G__26162 = 0;
                seq__26004_26134 = G__26159;
                chunk__26005_26135 = G__26160;
                count__26006_26136 = G__26161;
                i__26007_26137 = G__26162;
                continue;
              }
            } else {}
          }

          break;
        }
      } else {}

      return cljs.core.async.impl.channels.box(true);
    } else {
      var taker = function () {
        while (true) {
          var taker = self__.takes.pop();

          if (cljs.core.truth_(taker)) {
            if (cljs.core.truth_(taker.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null))) {
              return taker;
            } else {
              continue;
            }
          } else {
            return null;
          }

          break;
        }
      }();

      if (cljs.core.truth_(taker)) {
        var take_cb = taker.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
        handler.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
        cljs.core.async.impl.dispatch.run(function () {
          return take_cb.cljs$core$IFn$_invoke$arity$1 ? take_cb.cljs$core$IFn$_invoke$arity$1(val) : take_cb.call(null, val);
        });
        return cljs.core.async.impl.channels.box(true);
      } else {
        if (self__.dirty_puts > 64) {
          self__.dirty_puts = 0;
          self__.puts.cleanup(cljs.core.async.impl.channels.put_active_QMARK_);
        } else {
          self__.dirty_puts = self__.dirty_puts + 1;
        }

        if (cljs.core.truth_(handler.cljs$core$async$impl$protocols$Handler$blockable_QMARK_$arity$1(null))) {
          if (self__.puts.length < 1024) {} else {
            throw new Error(["Assert failed: ", ["No more than ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(1024), " pending puts are allowed on a single channel.", " Consider using a windowed buffer."].join(''), "\n", "(< (.-length puts) impl/MAX-QUEUE-SIZE)"].join(''));
          }

          self__.puts.unbounded_unshift(new cljs.core.async.impl.channels.PutBox(handler, val));
        } else {}

        return null;
      }
    }
  }
};

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$protocols$ReadPort$ = cljs.core.PROTOCOL_SENTINEL;

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$protocols$ReadPort$take_BANG_$arity$2 = function (this$, handler) {
  var self__ = this;
  var this$__$1 = this;

  if (!handler.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null)) {
    return null;
  } else {
    if (!(self__.buf == null) && cljs.core.count(self__.buf) > 0) {
      var temp__5802__auto__ = handler.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);

      if (cljs.core.truth_(temp__5802__auto__)) {
        var take_cb = temp__5802__auto__;
        var val = self__.buf.cljs$core$async$impl$protocols$Buffer$remove_BANG_$arity$1(null);
        var vec__26009 = cljs.core.not(self__.buf.cljs$core$async$impl$protocols$Buffer$full_QMARK_$arity$1(null)) && self__.puts.length > 0 ? function () {
          var cbs = cljs.core.PersistentVector.EMPTY;

          while (true) {
            var putter = self__.puts.pop();
            var put_handler = putter.handler;
            var val__$1 = putter.val;
            var cb = put_handler.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null) ? put_handler.cljs$core$async$impl$protocols$Handler$commit$arity$1(null) : false;
            var cbs__$1 = cljs.core.truth_(cb) ? cljs.core.conj.cljs$core$IFn$_invoke$arity$2(cbs, cb) : cbs;
            var done_QMARK_ = cljs.core.truth_(cb) ? cljs.core.reduced_QMARK_(self__.add_BANG_.cljs$core$IFn$_invoke$arity$2 ? self__.add_BANG_.cljs$core$IFn$_invoke$arity$2(self__.buf, val__$1) : self__.add_BANG_.call(null, self__.buf, val__$1)) : null;

            if (cljs.core.not(done_QMARK_) && cljs.core.not(self__.buf.cljs$core$async$impl$protocols$Buffer$full_QMARK_$arity$1(null)) && self__.puts.length > 0) {
              var G__26163 = cbs__$1;
              cbs = G__26163;
              continue;
            } else {
              return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [done_QMARK_, cbs__$1], null);
            }

            break;
          }
        }() : null;
        var done_QMARK_ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__26009, 0, null);
        var cbs = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__26009, 1, null);

        if (cljs.core.truth_(done_QMARK_)) {
          this$__$1.cljs$core$async$impl$channels$MMC$abort$arity$1(null);
        } else {}

        var seq__26012_26164 = cljs.core.seq(cbs);
        var chunk__26013_26165 = null;
        var count__26014_26166 = 0;
        var i__26015_26167 = 0;

        while (true) {
          if (i__26015_26167 < count__26014_26166) {
            var cb_26168 = chunk__26013_26165.cljs$core$IIndexed$_nth$arity$2(null, i__26015_26167);
            cljs.core.async.impl.dispatch.run(function (seq__26012_26164, chunk__26013_26165, count__26014_26166, i__26015_26167, cb_26168, val, vec__26009, done_QMARK_, cbs, take_cb, temp__5802__auto__, this$__$1) {
              return function () {
                return cb_26168.cljs$core$IFn$_invoke$arity$1 ? cb_26168.cljs$core$IFn$_invoke$arity$1(true) : cb_26168.call(null, true);
              };
            }(seq__26012_26164, chunk__26013_26165, count__26014_26166, i__26015_26167, cb_26168, val, vec__26009, done_QMARK_, cbs, take_cb, temp__5802__auto__, this$__$1));
            var G__26169 = seq__26012_26164;
            var G__26170 = chunk__26013_26165;
            var G__26171 = count__26014_26166;
            var G__26172 = i__26015_26167 + 1;
            seq__26012_26164 = G__26169;
            chunk__26013_26165 = G__26170;
            count__26014_26166 = G__26171;
            i__26015_26167 = G__26172;
            continue;
          } else {
            var temp__5804__auto___26173 = cljs.core.seq(seq__26012_26164);

            if (temp__5804__auto___26173) {
              var seq__26012_26174__$1 = temp__5804__auto___26173;

              if (cljs.core.chunked_seq_QMARK_(seq__26012_26174__$1)) {
                var c__4556__auto___26175 = cljs.core.chunk_first(seq__26012_26174__$1);
                var G__26176 = cljs.core.chunk_rest(seq__26012_26174__$1);
                var G__26177 = c__4556__auto___26175;
                var G__26178 = cljs.core.count(c__4556__auto___26175);
                var G__26179 = 0;
                seq__26012_26164 = G__26176;
                chunk__26013_26165 = G__26177;
                count__26014_26166 = G__26178;
                i__26015_26167 = G__26179;
                continue;
              } else {
                var cb_26180 = cljs.core.first(seq__26012_26174__$1);
                cljs.core.async.impl.dispatch.run(function (seq__26012_26164, chunk__26013_26165, count__26014_26166, i__26015_26167, cb_26180, seq__26012_26174__$1, temp__5804__auto___26173, val, vec__26009, done_QMARK_, cbs, take_cb, temp__5802__auto__, this$__$1) {
                  return function () {
                    return cb_26180.cljs$core$IFn$_invoke$arity$1 ? cb_26180.cljs$core$IFn$_invoke$arity$1(true) : cb_26180.call(null, true);
                  };
                }(seq__26012_26164, chunk__26013_26165, count__26014_26166, i__26015_26167, cb_26180, seq__26012_26174__$1, temp__5804__auto___26173, val, vec__26009, done_QMARK_, cbs, take_cb, temp__5802__auto__, this$__$1));
                var G__26181 = cljs.core.next(seq__26012_26174__$1);
                var G__26182 = null;
                var G__26183 = 0;
                var G__26184 = 0;
                seq__26012_26164 = G__26181;
                chunk__26013_26165 = G__26182;
                count__26014_26166 = G__26183;
                i__26015_26167 = G__26184;
                continue;
              }
            } else {}
          }

          break;
        }

        return cljs.core.async.impl.channels.box(val);
      } else {
        return null;
      }
    } else {
      var putter = function () {
        while (true) {
          var putter = self__.puts.pop();

          if (cljs.core.truth_(putter)) {
            if (cljs.core.async.impl.protocols.active_QMARK_(putter.handler)) {
              return putter;
            } else {
              continue;
            }
          } else {
            return null;
          }

          break;
        }
      }();

      if (cljs.core.truth_(putter)) {
        var put_cb = cljs.core.async.impl.protocols.commit(putter.handler);
        handler.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
        cljs.core.async.impl.dispatch.run(function () {
          return put_cb.cljs$core$IFn$_invoke$arity$1 ? put_cb.cljs$core$IFn$_invoke$arity$1(true) : put_cb.call(null, true);
        });
        return cljs.core.async.impl.channels.box(putter.val);
      } else {
        if (cljs.core.truth_(self__.closed)) {
          if (cljs.core.truth_(self__.buf)) {
            self__.add_BANG_.cljs$core$IFn$_invoke$arity$1 ? self__.add_BANG_.cljs$core$IFn$_invoke$arity$1(self__.buf) : self__.add_BANG_.call(null, self__.buf);
          } else {}

          if (cljs.core.truth_(function () {
            var and__4115__auto__ = handler.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null);

            if (cljs.core.truth_(and__4115__auto__)) {
              return handler.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
            } else {
              return and__4115__auto__;
            }
          }())) {
            var has_val = function () {
              var and__4115__auto__ = self__.buf;

              if (cljs.core.truth_(and__4115__auto__)) {
                return cljs.core.count(self__.buf) > 0;
              } else {
                return and__4115__auto__;
              }
            }();

            var val = cljs.core.truth_(has_val) ? self__.buf.cljs$core$async$impl$protocols$Buffer$remove_BANG_$arity$1(null) : null;
            return cljs.core.async.impl.channels.box(val);
          } else {
            return null;
          }
        } else {
          if (self__.dirty_takes > 64) {
            self__.dirty_takes = 0;
            self__.takes.cleanup(cljs.core.async.impl.protocols.active_QMARK_);
          } else {
            self__.dirty_takes = self__.dirty_takes + 1;
          }

          if (cljs.core.truth_(handler.cljs$core$async$impl$protocols$Handler$blockable_QMARK_$arity$1(null))) {
            if (self__.takes.length < 1024) {} else {
              throw new Error(["Assert failed: ", ["No more than ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(1024), " pending takes are allowed on a single channel."].join(''), "\n", "(< (.-length takes) impl/MAX-QUEUE-SIZE)"].join(''));
            }

            self__.takes.unbounded_unshift(handler);
          } else {}

          return null;
        }
      }
    }
  }
};

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$protocols$Channel$ = cljs.core.PROTOCOL_SENTINEL;

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$protocols$Channel$closed_QMARK_$arity$1 = function (_) {
  var self__ = this;

  var ___$1 = this;

  return self__.closed;
};

cljs.core.async.impl.channels.ManyToManyChannel.prototype.cljs$core$async$impl$protocols$Channel$close_BANG_$arity$1 = function (this$) {
  var self__ = this;
  var this$__$1 = this;

  if (self__.closed) {
    return null;
  } else {
    self__.closed = true;

    if (cljs.core.truth_(function () {
      var and__4115__auto__ = self__.buf;

      if (cljs.core.truth_(and__4115__auto__)) {
        return self__.puts.length === 0;
      } else {
        return and__4115__auto__;
      }
    }())) {
      self__.add_BANG_.cljs$core$IFn$_invoke$arity$1 ? self__.add_BANG_.cljs$core$IFn$_invoke$arity$1(self__.buf) : self__.add_BANG_.call(null, self__.buf);
    } else {}

    while (true) {
      var taker_26186 = self__.takes.pop();

      if (taker_26186 == null) {} else {
        if (taker_26186.cljs$core$async$impl$protocols$Handler$active_QMARK_$arity$1(null)) {
          var take_cb_26187 = taker_26186.cljs$core$async$impl$protocols$Handler$commit$arity$1(null);
          var val_26188 = cljs.core.truth_(function () {
            var and__4115__auto__ = self__.buf;

            if (cljs.core.truth_(and__4115__auto__)) {
              return cljs.core.count(self__.buf) > 0;
            } else {
              return and__4115__auto__;
            }
          }()) ? self__.buf.cljs$core$async$impl$protocols$Buffer$remove_BANG_$arity$1(null) : null;
          cljs.core.async.impl.dispatch.run(function (take_cb_26187, val_26188, taker_26186, this$__$1) {
            return function () {
              return take_cb_26187.cljs$core$IFn$_invoke$arity$1 ? take_cb_26187.cljs$core$IFn$_invoke$arity$1(val_26188) : take_cb_26187.call(null, val_26188);
            };
          }(take_cb_26187, val_26188, taker_26186, this$__$1));
        } else {}

        continue;
      }

      break;
    }

    if (cljs.core.truth_(self__.buf)) {
      self__.buf.cljs$core$async$impl$protocols$Buffer$close_buf_BANG_$arity$1(null);
    } else {}

    return null;
  }
};

cljs.core.async.impl.channels.ManyToManyChannel.getBasis = function () {
  return new cljs.core.PersistentVector(null, 7, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "takes", "takes", 298247964, null), cljs.core.with_meta(new cljs.core.Symbol(null, "dirty-takes", "dirty-takes", 575642138, null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "mutable", "mutable", 875778266), true], null)), new cljs.core.Symbol(null, "puts", "puts", -1883877054, null), cljs.core.with_meta(new cljs.core.Symbol(null, "dirty-puts", "dirty-puts", 57041148, null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "mutable", "mutable", 875778266), true], null)), cljs.core.with_meta(new cljs.core.Symbol(null, "buf", "buf", 1426618187, null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "tag", "tag", -1290361223), new cljs.core.Symbol(null, "not-native", "not-native", -236392494, null)], null)), cljs.core.with_meta(new cljs.core.Symbol(null, "closed", "closed", 720856168, null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "mutable", "mutable", 875778266), true], null)), new cljs.core.Symbol(null, "add!", "add!", 2046056845, null)], null);
};

cljs.core.async.impl.channels.ManyToManyChannel.cljs$lang$type = true;
cljs.core.async.impl.channels.ManyToManyChannel.cljs$lang$ctorStr = "cljs.core.async.impl.channels/ManyToManyChannel";

cljs.core.async.impl.channels.ManyToManyChannel.cljs$lang$ctorPrWriter = function (this__4369__auto__, writer__4370__auto__, opt__4371__auto__) {
  return cljs.core._write(writer__4370__auto__, "cljs.core.async.impl.channels/ManyToManyChannel");
};
/**
 * Positional factory function for cljs.core.async.impl.channels/ManyToManyChannel.
 */


cljs.core.async.impl.channels.__GT_ManyToManyChannel = function cljs$core$async$impl$channels$__GT_ManyToManyChannel(takes, dirty_takes, puts, dirty_puts, buf, closed, add_BANG_) {
  return new cljs.core.async.impl.channels.ManyToManyChannel(takes, dirty_takes, puts, dirty_puts, buf, closed, add_BANG_);
};

cljs.core.async.impl.channels.ex_handler = function cljs$core$async$impl$channels$ex_handler(ex) {
  console.log(ex);
  return null;
};

cljs.core.async.impl.channels.handle = function cljs$core$async$impl$channels$handle(buf, exh, t) {
  var else$ = function () {
    var fexpr__26050 = function () {
      var or__4126__auto__ = exh;

      if (cljs.core.truth_(or__4126__auto__)) {
        return or__4126__auto__;
      } else {
        return cljs.core.async.impl.channels.ex_handler;
      }
    }();

    return fexpr__26050.cljs$core$IFn$_invoke$arity$1 ? fexpr__26050.cljs$core$IFn$_invoke$arity$1(t) : fexpr__26050.call(null, t);
  }();

  if (else$ == null) {
    return buf;
  } else {
    return cljs.core.async.impl.protocols.add_BANG_.cljs$core$IFn$_invoke$arity$2(buf, else$);
  }
};

cljs.core.async.impl.channels.chan = function cljs$core$async$impl$channels$chan(var_args) {
  var G__26061 = arguments.length;

  switch (G__26061) {
    case 1:
      return cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$1 = function (buf) {
  return cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$2(buf, null);
};

cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$2 = function (buf, xform) {
  return cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$3(buf, xform, null);
};

cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$3 = function (buf, xform, exh) {
  return new cljs.core.async.impl.channels.ManyToManyChannel(cljs.core.async.impl.buffers.ring_buffer(32), 0, cljs.core.async.impl.buffers.ring_buffer(32), 0, buf, false, function () {
    var add_BANG_ = cljs.core.truth_(xform) ? xform.cljs$core$IFn$_invoke$arity$1 ? xform.cljs$core$IFn$_invoke$arity$1(cljs.core.async.impl.protocols.add_BANG_) : xform.call(null, cljs.core.async.impl.protocols.add_BANG_) : cljs.core.async.impl.protocols.add_BANG_;
    return function () {
      var G__26191 = null;

      var G__26191__1 = function G__26191__1(buf__$1) {
        try {
          return add_BANG_.cljs$core$IFn$_invoke$arity$1 ? add_BANG_.cljs$core$IFn$_invoke$arity$1(buf__$1) : add_BANG_.call(null, buf__$1);
        } catch (e26086) {
          var t = e26086;
          return cljs.core.async.impl.channels.handle(buf__$1, exh, t);
        }
      };

      var G__26191__2 = function G__26191__2(buf__$1, val) {
        try {
          return add_BANG_.cljs$core$IFn$_invoke$arity$2 ? add_BANG_.cljs$core$IFn$_invoke$arity$2(buf__$1, val) : add_BANG_.call(null, buf__$1, val);
        } catch (e26087) {
          var t = e26087;
          return cljs.core.async.impl.channels.handle(buf__$1, exh, t);
        }
      };

      G__26191 = function G__26191(buf__$1, val) {
        switch (arguments.length) {
          case 1:
            return G__26191__1.call(this, buf__$1);

          case 2:
            return G__26191__2.call(this, buf__$1, val);
        }

        throw new Error('Invalid arity: ' + arguments.length);
      };

      G__26191.cljs$core$IFn$_invoke$arity$1 = G__26191__1;
      G__26191.cljs$core$IFn$_invoke$arity$2 = G__26191__2;
      return G__26191;
    }();
  }());
};

cljs.core.async.impl.channels.chan.cljs$lang$maxFixedArity = 3;
Object.defineProperty(module.exports, "put_active_QMARK_", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.put_active_QMARK_;
  }
});
Object.defineProperty(module.exports, "__GT_t_cljs$core$async$impl$channels25997", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.__GT_t_cljs$core$async$impl$channels25997;
  }
});
Object.defineProperty(module.exports, "t_cljs$core$async$impl$channels25997", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.t_cljs$core$async$impl$channels25997;
  }
});
Object.defineProperty(module.exports, "chan", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.chan;
  }
});
Object.defineProperty(module.exports, "box", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.box;
  }
});
Object.defineProperty(module.exports, "MMC", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.MMC;
  }
});
Object.defineProperty(module.exports, "__GT_PutBox", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.__GT_PutBox;
  }
});
Object.defineProperty(module.exports, "abort", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.abort;
  }
});
Object.defineProperty(module.exports, "ex_handler", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.ex_handler;
  }
});
Object.defineProperty(module.exports, "MAX_DIRTY", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.MAX_DIRTY;
  }
});
Object.defineProperty(module.exports, "ManyToManyChannel", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.ManyToManyChannel;
  }
});
Object.defineProperty(module.exports, "handle", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.handle;
  }
});
Object.defineProperty(module.exports, "__GT_ManyToManyChannel", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.__GT_ManyToManyChannel;
  }
});
Object.defineProperty(module.exports, "PutBox", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.channels.PutBox;
  }
});